/**
 * Shell Application Entry Point
 *
 * Uses dynamic import to bootstrap the application.
 * This pattern is required for Module Federation to properly
 * initialize shared modules before the app loads.
 */

import('./bootstrap');
